import React from 'react';
import { EpicGamesFooter } from '@wf-components/footer-react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { getLocale } from '../../utils/local.utils';
import { selectConfigState } from '../../selectors/config.selector';
import { device } from '../../constants/breakpoint';

const FooterWrapper = styled.div`
    display: block;
    @media screen and ${device.laptop} {
        display: none;
    }
`;

export const GlobalFooter = () => {
    const locale = getLocale();
    const configState = useSelector(selectConfigState);
    return (
        <FooterWrapper>
            <EpicGamesFooter locale={locale} domain={configState?.globalBase} />;
        </FooterWrapper>
    );
};
